import React, { useState, useContext } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { cardStyle } from "../../utils";
import CheckoutService from "../../services/CheckoutService";
import { ModalContext } from "../../context/ModalContext";
import { navigate } from "@reach/router";
import { AuthContext } from "../../context/AuthContext";

const StripeCreditCard = ({ cart, element_id, discountCode, metadata, installmentsOptions }) => {
  const [processing, setProcessing] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const stripe = useStripe();
  const elements = useElements();

  const { user } = useContext(AuthContext);

  const { alert } = useContext(ModalContext);

  const handleError = (message) => {
    setProcessing(false);
    alert(`Hubo un error al procesar tu compra: ${message}`);
  };

  const handleSuccess = (purchase_id) => {
    setProcessing(false);
    navigate(`/gracias/${purchase_id}`);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);
    const card = elements.getElement(CardElement);
   
    const payment_method = await await stripe.createPaymentMethod({
      type: "card",
      card,
      billing_details: {
        email: user.email,
      },
    });

    if(payment_method.error){
      setProcessing(false);
      return alert(payment_method.error.message);
    }

    CheckoutService.attempt(element_id, discountCode, payment_method, cart, metadata)
      .then(async (res) => {
        const { clientSecret, purchase_id } = res.data;
        if (clientSecret) {
          const payload = await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
              card,
            },
          });
          if (payload.error) {
            handleError(payload.error.message);
          } else {
            handleSuccess(purchase_id);
          }
        } else {
          handleSuccess(purchase_id);
        }
      })
      .catch(error => {
        setProcessing(false);
        alert(error?.response?.data?.message);
        // handleCheckoutError(error, alert);
      });
  };

  const handleChange = async (event) => {
    setDisabled(event.empty);
  };

  return (
    <div className="container-fluid px-0">
      <form onSubmit={handleSubmit}>
        <h5 className="border-bottom pb-2 mb-3">Tarjeta de Crédito</h5>
        <CardElement
          id="card-element"
          options={cardStyle}
          className="form-control pt-2 my-2"
          onChange={handleChange}
        />
        <button className="btn btn-primary" disabled={processing || disabled}>
          {processing ? <div className="spinner-border"></div> : "Pagar Ahora"}
        </button>
      </form>
    </div>
  );
};

export default StripeCreditCard;
